(function () {
    'use strict';

    angular.module('ib-pmt-module', [
        'ib-pmt-voucher-otp-module',
        'ib-pmt-dcc-module',
        'ib-pmt-utils-module',
        'ib-pmt-nav-tab-module',
        'ib-reusable-module',
        'ib-pmt-donation-module',
        'ib-pmt-summary-module',
        'ib-pmt-terms-conditions-module',
        'ib-pmt-paypal-afop-button-module',
        'ib-pmt-total-price-module',
        'ib-pmt-services-http-module',
        'ib-pmt-disscount-module',
        'ib-pmt-on-hold-components-module',
        'ib-breakdown-module',
        'ib-pmt-disscount-multiple-module',
        'ib-pmt-credit-card-form',
        'ib-pmt-nemuru-afop',
        'ib-pmt-mercado-pago-afop',
        'ib-pmt-tab-new-module'
    ]);
})();
